import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { CustomLink } from 'ziphy-web-shared/basic/lib/buttons';
import styles from '@nedoShared/modules/notes/ui/sidebar/Sidebar.module.scss';
import { routeActions } from '@config/routeActions';
import { $legacyNotes as $notes } from '../LegacyNotes.store';
const items = [
    {
        id: 'results',
        tKey: 'label.history',
        icon: 'user',
    },
    {
        id: 'documents',
        tKey: 'label.docs',
        icon: 'documentRounded',
    },
];
const Sidebar = ({ className }) => {
    const { t } = useTranslation();
    const location = useLocation();
    function handleClick(id) {
        $notes.SET_SIDEBAR($notes.sidebar === id ? null : id);
    }
    return (_jsx("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: items.map((item) => item.id === 'results' ? (_jsxs(CustomLink, Object.assign({ className: classNames(styles.item, $notes.sidebar === item.id && styles.active), autoTarget: routeActions.PS_PATIENT({ patientId: $notes.patient.id, practiceId: $notes.encounter.practiceId }, { backToUrl: location.pathname }) }, { children: [_jsx("div", Object.assign({ className: styles.icon }, { children: _jsx(Icon, { type: item.icon }) })), _jsx("div", Object.assign({ className: styles.label }, { children: t(item.tKey) }))] }), item.id)) : (_jsxs("div", Object.assign({ className: classNames(styles.item, $notes.sidebar === item.id && styles.active), onClick: () => handleClick(item.id) }, { children: [_jsx("div", Object.assign({ className: styles.icon }, { children: _jsx(Icon, { type: item.icon }) })), _jsx("div", Object.assign({ className: styles.label }, { children: t(item.tKey) }))] }), item.id))) })));
};
export default observer(Sidebar);
